import { UseMutationResult, useMutation } from 'react-query'
import request from '../request'
import { Dealership } from '../../lib/types/Dealership'

export const useEditDealership = (): UseMutationResult<
  unknown,
  unknown,
  { data: Partial<Dealership>; id?: string },
  unknown
> => {
  return useMutation(({ data, id }: { data: Partial<Dealership>; id?: string }) =>
    request({
      url: `/admin/dealerships/${id}`,
      method: 'PATCH',
      data: data,
    }),
  )
}
